import React, { createContext } from 'react';

export const PermissionContext = createContext({ canEdit: true });

export function withPermission(Component) {
    return function WithPermission(props) {
        return <PermissionContext.Consumer>
            { permission => <Component permission={permission} {...props}/> }
        </PermissionContext.Consumer>
    }
}


// WEBPACK FOOTER //
// ./src/scripts/context.js